module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/05-57fdc9c73248ecec4dac43b02448d753.jpg";